import React, { Fragment } from 'react'
import { Form } from 'react-bootstrap'
import PropTypes from 'prop-types'

export const VideoChapter = ({ chapter, handleChange }) => {
  return (
    <Fragment>
      <p className="mt-4 mb-1">{chapter[0]}</p>
      {chapter[1].map(ch => (
        <div className="mb-1" key={ch[1]}>
          <input
            value={ch[0]}
            type="checkbox"
            className="mr-3"
            onChange={e => handleChange(e)}
          />
          <Form.Label>{ch[1] === '' ? 'No Title' : ch[1]}</Form.Label>
        </div>
      ))}
    </Fragment>
  )
}

VideoChapter.propTypes = {
  chapter: PropTypes.array,
  handleChange: PropTypes.func,
}
